var map = {
	"./FBX": 35,
	"./FBX.js": 35,
	"./OBJ": 36,
	"./OBJ.js": 36,
	"./STL": 37,
	"./STL.js": 37
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58;


//////////////////
// WEBPACK FOOTER
// ./bin/plugins ^\.\/.*$
// module id = 58
// module chunks = 0